const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';
const AI_ENDPOINT = process.env.REACT_APP_AI_ENDPOINT || '/api/ai/chat';

export interface AIResponse {
  id: string;
  object: string;
  created: number;
  model: string;
  choices: Array<{
    index: number;
    message: {
      role: string;
      content: string;
    };
    finish_reason: string;
  }>;
  usage: {
    prompt_tokens: number;
    completion_tokens: number;
    total_tokens: number;
  };
}

export interface AIRequest {
  message: string;
  context?: string;
  userId?: string;
}

class AIService {
  private baseURL: string;

  constructor() {
    this.baseURL = API_BASE_URL;
  }

  async chat(request: AIRequest): Promise<AIResponse> {
    try {
      const response = await fetch(`${this.baseURL}${AI_ENDPOINT}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(request),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`API Error: ${response.status} - ${errorData.error || response.statusText}`);
      }

      const data: AIResponse = await response.json();
      return data;
    } catch (error) {
      console.error('AI Service Error:', error);
      throw error;
    }
  }

  async healthCheck(): Promise<any> {
    try {
      const response = await fetch(`${this.baseURL}/api/ai/health`);
      if (!response.ok) {
        throw new Error(`Health check failed: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('AI Health Check Error:', error);
      throw error;
    }
  }
}

export const aiService = new AIService();